'use strict';


import { EnvironmentLayer } from './EnvironmentLayer';

export class LeisureEnvironment extends EnvironmentLayer{
    constructor () {
        super('Leisure');
    }

}